@let title = titleSg();
@let subtitle = subtitleSg();

<div class="atn-summit-pulse-section">
  <div class="atn-summit-pulse-section__header">
    <h2 class="atn-summit-pulse-section__title">{{ title }}</h2>
    @if (subtitle) {
      <h3 class="atn-summit-pulse-section__subtitle">
        {{ subtitle }}
      </h3>
    }
  </div>
  <ng-content></ng-content>
</div>
